import 'regenerator-runtime/runtime';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { App, FileUploader } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { AnyAction } from 'redux';
import { AxiosError } from 'axios';
import { CheckoutAction, CheckoutActions } from '../checkout.actions';
import { FileToDeletePayload } from '../action-types/haushaltModalPayloads';

export const FILE_DELETION_URL = '/privatschutz/api/sds/';
const checkoutActions = new CheckoutActions();

export const DOCUMENTID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/i;

export enum FILE_DELETION_EVENTS {
  FILE_DELETION_SUCCESSFUL = 'FILE_DELETION_SUCCESSFUL_EVENT',
  FILE_DELETION_FAILED = 'FILE_DELETION_FAILED_EVENT',
}

export function* watchFileDeleted() {
  yield takeEvery(
    CheckoutActions.FILE_DELETION_REQUESTED,
    safeSaga(fileDeletionSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    FILE_DELETION_EVENTS.FILE_DELETION_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    FILE_DELETION_EVENTS.FILE_DELETION_FAILED,
    safeSaga(errorCallback, App.SHOP_CHECKOUT),
  );
}

export function* fileDeletionSaga(action: CheckoutAction<FileToDeletePayload>) {
  const globalPut = GlobalPut.getInstance();
  const { documentId, fileUploaderId, angebotsId } = action.payload;
  yield put({
    type: CheckoutActions.FILE_MODIFICATION_IN_PROGRESS,
  });
  yield call(
    globalPut.put,
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      url: FILE_DELETION_URL + documentId + '/delete',
      method: HTTP_METHOD.POST,
      successEvent: FILE_DELETION_EVENTS.FILE_DELETION_SUCCESSFUL,
      errorEvent: FILE_DELETION_EVENTS.FILE_DELETION_FAILED,
      additionalData: {
        fileUploaderId,
        angebotsId,
      },
      retry: {
        times: 3,
        delay: 100,
      },
    }),
  );
}

export function* successCallback(successAction: AnyAction) {
  const payload = successAction.doRequestAction.payload;
  const url = payload.url;
  const extractedDocumentId = url.match(DOCUMENTID_REGEX)[0];
  yield put(
    checkoutActions.fileDeleted(
      extractedDocumentId,
      payload.additionalData.fileUploaderId,
      payload.additionalData.angebotsId,
    ),
  );
  if (payload.additionalData.fileUploaderId === FileUploader.ELEMENTAR_FRAGEBOGEN) {
    yield put(
      checkoutActions.elementarFragebogenfilesSuccessfullyDeleted(
        extractedDocumentId,
        payload.additionalData.angebotsId,
      ),
    );
  }
  yield put({
    type: CheckoutActions.FILE_MODIFICATION_FINISHED,
  });
}

export function* errorCallback(failureAction: DoRequestResponse<AxiosError>) {
  yield put(
    checkoutActions.fileDeletionFailed(
      (failureAction.doRequestAction.payload.additionalData as Record<string, string>)['fileUploaderId'],
    ),
  );
  yield put({
    type: CheckoutActions.FILE_MODIFICATION_FINISHED,
  });
}
